import { RootState } from '@shared/model';

export const selectGenerationState = (state: RootState) => state.invoiceGenerationState;
export const selectGenerationLoading = (state: RootState) => state.invoiceGenerationState.isLoading;
export const selectGenerationStateId = (state: RootState) => state.invoiceGenerationState.stateId;
export const selectExcelFiles = (state: RootState) => state.invoiceGenerationState.excelFiles;
export const selectGenerationErrors = (state: RootState) => state.invoiceGenerationState.progress.errors;
export const selectGeneratedTotal = (state: RootState) => state.invoiceGenerationState.progress.total;
export const selectFailedGeneration = (state: RootState) => state.invoiceGenerationState.progress.failed;
export const selectGeneratedSuccessfullyCount = (state: RootState) => state.invoiceGenerationState.progress.generated;
export const selectGenerationProgress = (state: RootState) => state.invoiceGenerationState.progress;
